var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g({attrs:{"close":_vm.close,"color":_vm.color,"dark":_vm.dark,"outlined":_vm.outlined,"small":!_vm.small,"x-small":_vm.small}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }